export default __webpack_public_path__ + "static/media/loginbackground.e3522048.svg";